import { fetchUserRentalContracts, buildRentalLibraryItems } from './firestoreService';

export type { RentalLibraryItem } from '../types/firestore.types';

export class LibraryServiceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LibraryServiceError';
  }
}

export async function fetchUserLibrary(uid: string) {
  const contracts = await fetchUserRentalContracts(uid);
  return buildRentalLibraryItems(contracts);
}

export const libraryService = {
  fetchUserLibrary,
};

export default libraryService;
